import actions from "../handlers/action";

const apply = (div, html, callback) => {
    document.querySelectorAll(div).forEach((element)=>{
        element.innerHTML = html;
    });
    actions.bind();
    callback && callback();
}

const hidePreloader = () => {
    document.querySelectorAll('.preloader-main').forEach((element)=>{
        element.style.display = 'none';
    });
}


export default {
    apply,
    hidePreloader
};


// WEBPACK FOOTER //
// ./Statics/scripts/paywall/helpers/view.js